/** @format */

import { useEffect, useState } from "react";
import Input from "../../extra/Input";
import SettingBox from "./SettingBox";
import { connect, useDispatch, useSelector } from "react-redux";
import { getSetting, updateSetting, handleToggleSwitch } from "../../store/setting/setting.action";
import { getWithdraw } from "../../store/withdraw/withdraw.action";
import Button from "../../extra/Button";
import InfoTooltip from "../../../Component/extra/InfoTooltip";
import { flutterWaveContent, paystackContent } from "../../../Component/extra/infoContent";

const PaymentSetting = (props) => {
	const { setting } = useSelector((state) => state.setting);
	const dispatch = useDispatch();
	const [flutterWaveSwitch, setFlutterWaveSwitch] = useState(false);
	const [isCashOnDelivery, setIsCashOnDelivery] = useState(false);
	const [flutterWaveId, setFlutterWaveId] = useState("");
	const [paystackPublicKey, setPaystackPublicKey] = useState("");
	const [paystackSecretKey, setPaystackSecretKey] = useState("");
	const [paystackSwitch, setPaystackSwitch] = useState(false);

	const [error, setError] = useState({
		flutterWaveId: "",
		paystackPublicKey: "",
		paystackSecretKey: "",
	});

	useEffect(() => {
		dispatch(getSetting());
	}, [dispatch]);

	useEffect(() => {
		dispatch(getWithdraw());
	}, [dispatch]);

	useEffect(() => {
		setFlutterWaveSwitch(setting?.flutterWaveSwitch);
		setIsCashOnDelivery(setting?.isCashOnDelivery);
		// Secrets are not returned by GET /setting — keep blank; backend
		// preserves the saved value when these fields are omitted on update.
		setFlutterWaveId("");
		// paystack
		setPaystackPublicKey(setting?.paystackPublicKey || "");
		setPaystackSecretKey("");
		setPaystackSwitch(setting?.paystackSwitch || false);
	}, [setting]);

	const handleSubmit = () => {
		if (!paystackPublicKey) {
			let error = {};
			if (!paystackPublicKey) error.paystackPublicKey = "Paystack Public Key is required";
			return setError({ ...error });
		} else {
			let settingData = {
				paystackPublicKey,
			};

			// Only send secrets when the admin actually typed a new value.
			if (flutterWaveId) settingData.flutterWaveId = flutterWaveId;
			if (paystackSecretKey) settingData.paystackSecretKey = paystackSecretKey;

			props.updateSetting(settingData, setting?._id);
		}
	};

	const handleClick = (type) => {
		props.handleToggleSwitch(setting?._id, type);
	};

	return (
		<>
			<div className='mainSettingBar' style={{ margin: "0px" }}>
				<div className='settingBar '>
					<div className='settingHeader primeHeader'>
						<div className='col-12 headname' style={{ marginTop: "15px", marginBottom: "-5px" }}>
							Payment Setting{" "}
						</div>
					</div>
					<div className='settingMain'>
						<div className='row'>
							{/*-------------- Box 1 --------------*/}

							<SettingBox
								submit={(e) => handleSubmit(e)}
								title={`Flutter Wave Setting`}
								toggleSwitch={{
									switchName: "FlutterWave",
									switchValue: flutterWaveSwitch,
									handleClick: () => {
										handleClick("flutterWave");
									},
								}}>
								<Input
									type={`password`}
									label={`FlutterWave Id`}
									value={flutterWaveId}
									newClass={`col-12`}
									placeholder={`Leave blank to keep saved value`}
									errorMessage={error.flutterWaveId && error.flutterWaveId}
									onChange={(e) => {
										setFlutterWaveId(e.target.value);
									}}
								/>

								<div
									style={{
										width: "100%",
										display: "flex",
										justifyContent: "flex-end",
									}}>
									<InfoTooltip title='Flutterwave Setting' content={flutterWaveContent} />
								</div>
							</SettingBox>

							<SettingBox
								submit={(e) => handleSubmit(e)}
								title={`Paystack Payment Setting`}
								toggleSwitch={{
									switchName: "Paystack",
									switchValue: paystackSwitch,
									handleClick: () => {
										handleClick("paystack");
									},
								}}>
								<Input
									type={`text`}
									label={`Paystack Public Key`}
									value={paystackPublicKey}
									newClass={`col-12`}
									placeholder={`Enter your Paystack Public Key....`}
									errorMessage={error.paystackPublicKey && error.paystackPublicKey}
									onChange={(e) => {
										setPaystackPublicKey(e.target.value);
										if (!e.target.value) {
											return setError({
												...error,
												paystackPublicKey: `Paystack Public Key Is Required`,
											});
										} else {
											return setError({
												...error,
												paystackPublicKey: "",
											});
										}
									}}
								/>

								<Input
									type={`password`}
									label={`Paystack Secret Key`}
									value={paystackSecretKey}
									newClass={`col-12`}
									placeholder={`Leave blank to keep saved value`}
									errorMessage={error.paystackSecretKey && error.paystackSecretKey}
									onChange={(e) => {
										setPaystackSecretKey(e.target.value);
									}}
								/>
								<div
									style={{
										width: "100%",
										display: "flex",
										justifyContent: "flex-end",
									}}>
									<InfoTooltip title='Paystack Setting' content={paystackContent} />
								</div>
							</SettingBox>

							<SettingBox
								submit={(e) => handleSubmit(e)}
								title={`Cash On Delivery`}
								toggleSwitch={{
									switchName: "COD",
									switchValue: isCashOnDelivery,
									handleClick: () => {
										handleClick("isCashOnDelivery");
									},
								}}></SettingBox>

							{/* Box 6 */}
						</div>
						<div className='row mt-3'>
							<div className='col-12 d-flex justify-content-end'>
								<Button newClass={`whiteFont`} btnName={`Submit`} btnColor={`btnBlackPrime`} style={{ width: "90px", borderRadius: "8px" }} onClick={(e) => handleSubmit(e)} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default connect(null, {
	getSetting,
	updateSetting,
	handleToggleSwitch,
	getWithdraw,
})(PaymentSetting);
